export default __webpack_public_path__ + "static/media/logo-new.6d03be2e.png";